import { EmittersPolygonShape } from "./EmittersPolygonShape.js";
import { EmittersPolygonShapeOptions } from "./Options/Classes/EmittersPolygonShapeOptions.js";
export class EmittersPolygonShapeGenerator {
    generate(position, size, fill, options) {
        const shapeOptions = new EmittersPolygonShapeOptions();
        shapeOptions.load(options);
        return new EmittersPolygonShape(position, size, fill, shapeOptions);
    }
}
